import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import 'babel-polyfill'
import './validations/Validations'
import '@/components/Shared'
import './plugins/vee-validate-rules'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueSimpleSVG from 'vue-simple-svg'
import VueVirtualScroller from 'vue-virtual-scroller'

import BaseService from './services/BaseService'

import UrlBuilderMixin from './Mixins/UrlBuilderMixin'

Vue.config.productionTip = false

BaseService.start()

Vue.use(VueSimpleSVG)
Vue.use(VueVirtualScroller)

const globalData = new Vue({ data: { $appConfig: {}, $idUnimed: -1, $codigoUnimed: -1 } })

Vue.mixin({
  mixins: [UrlBuilderMixin],

  computed: {
    $appConfig: {
      get: function () {
        return globalData.$data.$appConfig
      },
      set: function (newConfig) {
        globalData.$data.$appConfig = newConfig
      }
    },

    $idUnimed: {
      get: function () {
        return globalData.$data.$idUnimed
      },
      set: function (id) {
        globalData.$data.$idUnimed = id
      }
    },

    $codigoUnimed: {
      get: function () {
        return globalData.$data.$codigoUnimed
      },
      set: function (codigo) {
        globalData.$data.$codigoUnimed = codigo
      }
    }
  }
})

new Vue({
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
